import { ArrowUpRight } from '@phosphor-icons/react';

export default ArrowUpRight;